module.exports = __webpack_public_path__ + "static/media/team2.b60d7a0b.webp";